module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/socket-us-240d6bac812e803cc1a4c4dcce1d8b8b.svg";